import { useAxios } from "@/app/providers/AxiosProvider";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export default function useDuplicateFloat() {
  const api = useAxios();
  const client = useQueryClient();

  const mutation = useMutation({
    mutationFn: (floatId) => {
      return api.post(`/floats/${floatId}/duplicate`, {});
    },
    onSuccess: () => {
      client.invalidateQueries({ queryKey: ["floats"] });
    },
  });

  return mutation.mutate;
}
